import React, {useCallback, useRef} from 'react';
import {getSrcFromU8Array} from '@priority-software/priority-utils/lib/file-processing';
import {Icon, PriorityIcon, Text} from '@priority-software/priority-style-react';
import {sendMonitor} from '../../utils/monitoring';
import {AttachmentType} from './index';
import styles from './styles.module.scss';
import classNames from 'classnames';
import {createDataTestId} from '../../utils/dataTestId';

type Props = {
    readOnly: boolean;
    file: AttachmentType;
    monitor?: {send: boolean; text: string};
    setFile: (file: File[]) => Promise<void>;
    placeholder?: string;
    accept?: string;
    componentClasses?: string;
    icon?: PriorityIcon;
    multiple?: boolean;
};

export const Uploader = (props: Props) => {
    const {readOnly, file, monitor, placeholder, setFile, accept, componentClasses, multiple} =
        props;
    const inputRef = useRef<HTMLInputElement>(null);

    const openFileExplorer = useCallback(() => {
        if (inputRef.current) {
            inputRef.current.value = null;
            inputRef.current.click();
        }
    }, []);

    const onInputFileChange = useCallback(
        async e => {
            e.preventDefault();

            await setFile(e.target.files);
        },
        [setFile]
    );

    const monitorInputClick = useCallback(() => {
        if (!file?.Data && monitor?.send) {
            sendMonitor(monitor.text);
        }
    }, [monitor, file]);

    if (readOnly && !file?.Data) {
        return null;
    } else if (file?.Data && file.MimeType) {
        const src = getSrcFromU8Array(file.Data, file.MimeType);
        return (
            <div className={styles.previewWrap}>
                <img className={styles.previewImg} src={src} alt="Logo" />
            </div>
        );
    } else {
        return (
            <div className={styles.fileUploaderContainer}>
                <div
                    className={classNames(styles.dropzone, componentClasses)}
                    onClick={openFileExplorer}
                    {...createDataTestId(`uploader`, false)}
                >
                    <input
                        ref={inputRef}
                        className={styles.input}
                        type="file"
                        multiple={multiple}
                        accept={accept}
                        onChange={onInputFileChange}
                        onClick={monitorInputClick}
                    />

                    <Text tag="div" skin="paragraph-2" componentClasses={styles.text}>
                        {placeholder}
                    </Text>

                    <Icon icon={props.icon} />
                </div>
            </div>
        );
    }
};
